import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

interface CategoryDropdownProps {
  onSelect: (url: string) => void;
}

export default function CategoryDropdown({ onSelect }: CategoryDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Select Category");
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelected(cat.name);
    setIsOpen(false);
    onSelect(cat.url);
  };

  return (
    <div ref={dropdownRef} className="relative w-full max-w-md">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between bg-background-50/90 backdrop-blur-sm border border-background-200/70 rounded-full px-5 py-3 text-sm text-foreground-700 hover:border-background-300/60 transition-all cursor-pointer"
      >
        <span className={selected === "Select Category" ? "text-foreground-400" : "text-foreground-800"}>
          {selected}
        </span>
        <i className={`${isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-foreground-400 transition-transform`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 left-0 right-0 bg-background-50 border border-background-200/70 rounded-2xl shadow-lg max-h-64 overflow-y-auto z-50">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => handleSelect(cat)}
              className="w-full text-left px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 transition-colors first:rounded-t-2xl last:rounded-b-2xl flex items-center gap-3 cursor-pointer whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                <i className={cat.icon}></i>
              </span>
              {cat.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}